import React from "react";
import { Image, Link, Text } from "@sitecore-jss/sitecore-jss-react";
import RichTextPanel from "@clarion/foundation/dist/Helpers/components/RichTextPanel";
import "./index.css";
const FooterSecondary = ({
  fields,
  templateIds,
  policyLinks = [],
  siteLinks = [],
  imageParams = {
    h: 60,
    w: "auto",
    mh: 60
  }
}) => {
  for (let i = 0; i < fields.items.length; i += 1) {
    let item = fields.items[i];
    switch (item.templateId) {
      case templateIds.PolicyLinkFooter:
        {
          policyLinks.push(item);
          break;
        }
      case templateIds.GroupSitesFooter:
        {
          siteLinks.push(item);
          break;
        }
      default:
        {
          break;
        }
    }
  }
  const manageCookies = () => {
    if (window.CookieControl) {
      window.CookieControl.open();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "footer__secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "qa-footer__secondary-wrapper footer__secondary-wrapper wrapper"
  }, siteLinks.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "footer__sites"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    className: "qa-footer__sites-header footer__sites-header",
    field: fields.GroupSitesTitle
  }), /*#__PURE__*/React.createElement("ul", {
    className: "footer__sites-list"
  }, siteLinks.map(item => {
    return /*#__PURE__*/React.createElement("li", {
      className: "qa-footer__sites-item",
      key: item.id
    }, /*#__PURE__*/React.createElement(Link, {
      className: "footer__sites-link",
      field: item.fields.Link
    }, /*#__PURE__*/React.createElement(Image, {
      className: "footer__sites-logo",
      width: "60",
      height: imageParams.h,
      media: item.fields.Logo,
      imageParams: imageParams
    }), /*#__PURE__*/React.createElement("span", {
      className: "visually-hidden"
    }, item.fields.Link.value.text)));
  }))), /*#__PURE__*/React.createElement(RichTextPanel, {
    className: "qa-footer__info copy-small footer__info",
    text: fields.Body
  }), (policyLinks.length > 0 || fields.CookieManagerLabel && fields.CookieManagerLabel.value) && /*#__PURE__*/React.createElement("ul", {
    className: "footer__policy"
  }, policyLinks.map(item => {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id,
      className: "qa-footer__policy-item footer__policy-item"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "footer__policy-link general-link",
      field: item.fields.Link
    }));
  }), fields.CookieManagerLabel && fields.CookieManagerLabel.value && /*#__PURE__*/React.createElement("li", {
    className: "qa-footer__policy-item footer__policy-item"
  }, /*#__PURE__*/React.createElement("button", {
    className: "footer__policy-link general-link",
    onClick: manageCookies
  }, fields.CookieManagerLabel.value)))));
};
export default FooterSecondary;